import isSameDay from "date-fns/esm/isSameDay";

import DateRange from "@mapmycustomers/shared/types/range/DateRange";

import { formatDate } from "@app/util/formatters";

const formatDateRange = (dateRange: DateRange, format: string = "PPP", sameDayFormat = "PPPP") => {
  if (isSameDay(dateRange.startDate, dateRange.endDate)) {
    return formatDate(dateRange.startDate, sameDayFormat);
  }
  return `${formatDate(dateRange.startDate, format)} — ${formatDate(dateRange.endDate, format)}`;
};

export default formatDateRange;
